/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgramImageReference } from '../../models/education-program-image-reference';

export interface GetEducationProgramImageReferences$Params {
  educationProgramId: string;
}

export function getEducationProgramImageReferences(http: HttpClient, rootUrl: string, params: GetEducationProgramImageReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EducationProgramImageReference>>> {
  const rb = new RequestBuilder(rootUrl, getEducationProgramImageReferences.PATH, 'get');
  if (params) {
    rb.path('educationProgramId', params.educationProgramId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EducationProgramImageReference>>;
    })
  );
}

getEducationProgramImageReferences.PATH = '/educationprogram/{educationProgramId}/images';
